export const MIN_HEIGHT_TEXTAREA = 100;
export const MAX_HEIGHT_TEXTAREA = 200;
